import * as React from "react";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import { ReactComponent as StarSvg } from 'assets/images/logo/Stars.svg';
import { useSelector } from "react-redux";
import { getSite } from "../ducks/selectors";
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';
import "../styles/site-location.scss";
import { getQuickLinkContactsList } from "modules/cbre-flow-view-management";

type ExternalReportsProps = {
    data?: any
};

const ExternalReports: React.FC<ExternalReportsProps> = () => {

    const [expandedAccordion, setExpandedAccordion] = React.useState<string | false>('site-0');
      const allQuickLinks:any[] = useSelector(getQuickLinkContactsList);

    const hasSingleSite = allQuickLinks.length === 1;

    const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpandedAccordion(isExpanded ? panel : false);
    };

    const renderQuickLinks = (quickLinks: any[]) => (
        quickLinks.map((data: any) => (
            <a 
                className="item" 
                rel="noreferrer" 
                href={data.quickLinkUrl} 
                target="_blank" 
                key={data.quickLinkName}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    textDecoration: 'none',
                    color: '#333',
                    borderBottom: '1px solid #E0E0E0',
                    transition: 'background-color 0.2s',
                }}
            >
                <Typography variant="body2" style={{ fontSize: '14px' }}>
                    {data.quickLinkName}
                </Typography>
                <OpenInNewIcon sx={{ fontSize: '18px', color: '#666' }} />
            </a>
        ))
    );

    if (allQuickLinks.length === 0) {
        return (
            <div className="external-report-container">
                <div className="help-content w-100">
                    <p className="text-center p-3 m-0">No external link available at this time.</p>
                </div>
            </div>
        );
    }

    if (hasSingleSite) {
        if(allQuickLinks[0].sitequicklinks.length === 0) {
            return (
                <div className="external-report-container">
                    <div className="help-content w-100">
                        <p className="text-center p-3 m-0">No external link available at this time.</p>
                    </div>
                </div>
            );
        }
        // Single site view - flat list
        return (
            <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', overflow: 'hidden' }}>
                {renderQuickLinks(allQuickLinks[0].sitequicklinks)}
            </Box>
        );
    }

    // Multiple sites view - accordion
    return (
        <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', overflow: 'hidden' }}>
            {allQuickLinks.map((site, index) => (
                <Accordion
                    key={`site-${index}`}
                    expanded={expandedAccordion === `site-${index}`}
                    onChange={handleAccordionChange(`site-${index}`)}
                    sx={{
                        boxShadow: 'none',
                        '&:before': { display: 'none' },
                        border: 'none',
                        marginBottom: 0,
                        backgroundColor: '#fff'
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            backgroundColor: '#F5F5F5',
                            minHeight: '48px',
                            '&.Mui-expanded': {
                                minHeight: '48px'
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '12px 0'
                            },
                            borderBottom: '1px solid #E0E0E0'
                        }}
                    >
                        <Typography style={{ fontWeight: 500, fontSize: '14px' }}>{site.siteName}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: 0 }}>
                        <Box>
                            {renderQuickLinks(site.sitequicklinks)}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default ExternalReports;